import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { IconComponent } from '@libs/stand-alone-components/commons/icon/icon.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-deposit-button',
  templateUrl: './deposit-button.component.html',
  styleUrls: ['./deposit-button.component.scss'],

  imports: [CommonModule, TranslateModule, IconComponent, RouterLink],
})
export class DepositButtonComponent {}
